import React from 'react';
import { Tabs, TabsContent, TabsTrigger } from "@/components/ui/tabs";
import ResponsiveTabsList from '@/components/shared/ResponsiveTabsList';
import CategoriesSettings from '@/components/cost-center/settings/CategoriesSettings';
import TradesSettings from '@/components/cost-center/settings/TradesSettings';
import UnitsSettings from '@/components/cost-center/settings/UnitsSettings';
import MarkupSettings from '@/components/cost-center/settings/MarkupSettings';
import BrowseCategoriesSettings from '@/components/cost-center/settings/BrowseCategoriesSettings';
import PageLayout from '@/components/layout/PageLayout';
import PageHeader from '@/components/layout/PageHeader';

const CostCenterSettingsPage = () => {
  return (
    <PageLayout>
      <PageHeader
        title="Cost Center Settings"
        description="Configure categories, trades, units and markup settings"
      />
      
      <div className="bg-background rounded-lg shadow p-4 md:p-6">
        <Tabs defaultValue="categories">
          <ResponsiveTabsList className="mb-6">
            <TabsTrigger value="categories">Categories</TabsTrigger>
            <TabsTrigger value="trades">Trades</TabsTrigger>
            <TabsTrigger value="units">Units</TabsTrigger>
            <TabsTrigger value="markup">Markup & Margin</TabsTrigger>
            <TabsTrigger value="browse">Browse Categories</TabsTrigger>
          </ResponsiveTabsList>
          
          <TabsContent value="categories">
            <CategoriesSettings />
          </TabsContent>
          
          <TabsContent value="trades">
            <TradesSettings />
          </TabsContent>
          
          <TabsContent value="units">
            <UnitsSettings />
          </TabsContent>
          
          <TabsContent value="markup">
            <MarkupSettings />
          </TabsContent>

          <TabsContent value="browse">
            <BrowseCategoriesSettings />
          </TabsContent>
        </Tabs>
      </div>
    </PageLayout>
  );
};

export default CostCenterSettingsPage;
